var render = function render(){
  var _vm$customer, _vm$customer2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": `${_vm.year}年${_vm.month}月-对账单-${(_vm$customer = _vm.customer) === null || _vm$customer === void 0 ? void 0 : _vm$customer.name}`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('h1', [_vm._v(_vm._s((_vm$customer2 = _vm.customer) === null || _vm$customer2 === void 0 ? void 0 : _vm$customer2.name))]), _c('h1', [_vm._v(_vm._s(_vm.year) + "年" + _vm._s(_vm.month) + "月")]), _c('Row', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('h3', [_vm._v("对账单是否已收到")])]), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.duiZhangDanSigned,
      callback: function ($$v) {
        _vm.duiZhangDanSigned = $$v;
      },
      expression: "duiZhangDanSigned"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "true",
      "border": ""
    }
  }, [_vm._v("已收到")]), _c('Radio', {
    attrs: {
      "label": "false",
      "border": ""
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _c('Row', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('h3', [_vm._v("对账单上传")])]), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v(" 待开发 ")])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }